import { render, staticRenderFns } from "./ChatDistributionsByHandleType.vue?vue&type=template&id=e0924e4a&scoped=true"
import script from "./ChatDistributionsByHandleType.vue?vue&type=script&lang=js"
export * from "./ChatDistributionsByHandleType.vue?vue&type=script&lang=js"
import style0 from "./ChatDistributionsByHandleType.vue?vue&type=style&index=0&id=e0924e4a&prod&lang=scss"
import style1 from "./ChatDistributionsByHandleType.vue?vue&type=style&index=1&id=e0924e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0924e4a",
  null
  
)

export default component.exports